import { render, staticRenderFns } from "./ExpenseSettings.vue?vue&type=template&id=d2987c5e&"
import script from "./ExpenseSettings.vue?vue&type=script&lang=js&"
export * from "./ExpenseSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports